import MessengerNavItem from './MessengerNavItem';

export default MessengerNavItem;
